export default __webpack_public_path__ + "static/media/Samsung Galaxy S20+.d784ed25.png";